<template>
  <div class="imprint">
    <h1 class="pa-3 display-2">
      404
    </h1>
  </div>
</template>


<script>
export default {
  name: 'ElilNotFound',
};
</script>



// WEBPACK FOOTER //
// src/components/ElilNotFound.vue